import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_date_picker = _resolveComponent("van-date-picker");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $setup.show,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $setup.show = $event),
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_date_picker, {
      modelValue: $setup.currentDate,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.currentDate = $event),
      title: "选择日期",
      "columns-type": $props.columnsType,
      "min-date": $setup.minDate,
      "max-date": $setup.maxDate,
      onConfirm: $setup.onConfirmClick,
      onCancel: $setup.onCancelClick
    }, null, 8, ["modelValue", "columns-type", "min-date", "max-date", "onConfirm", "onCancel"])]),
    _: 1
  }, 8, ["show"]);
}